/**
 * @generated SignedSource<<7e6c9bdc35c473bd4381053089853c19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type CompleteProfileCurriculumItemFormQuery$variables = {
  organizationId: string;
  userId: string;
};
export type CompleteProfileCurriculumItemFormQuery$data = {
  readonly user: {
    readonly organizationMembership?: {
      readonly organization: {
        readonly profileWebForm: {
          readonly currentRevision: {
            readonly id: string;
            readonly questions: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly isRequired: boolean;
                  readonly options: ReadonlyArray<{
                    readonly id: string;
                    readonly label: string;
                  }> | null;
                  readonly ordering: number;
                  readonly richEditorBody: string;
                  readonly type: WebFormQuestionType;
                };
              }>;
            };
            readonly webFormId: string;
          };
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"ProfileSettingsCustomFormFieldsFragment" | "ProfileSettingsProfileFormFieldsFragment">;
      };
      readonly profileValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly profileField: {
              readonly webFormQuestionId: string | null;
            };
            readonly selectedOptions: ReadonlyArray<string> | null;
            readonly value: string;
            readonly webFormAnswer: {
              readonly body: string | null;
              readonly selectedOptions: ReadonlyArray<string> | null;
            } | null;
          };
        }>;
      };
    } | null;
  } | null;
};
export type CompleteProfileCurriculumItemFormQuery = {
  response: CompleteProfileCurriculumItemFormQuery$data;
  variables: CompleteProfileCurriculumItemFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "userId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webFormQuestionId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedOptions",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "WebFormRevision",
  "kind": "LinkedField",
  "name": "currentRevision",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webFormId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormQuestionNodeConnection",
      "kind": "LinkedField",
      "name": "questions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WebFormQuestionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WebFormQuestion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "richEditorBody",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ordering",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isRequired",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WebFormQuestionOption",
                  "kind": "LinkedField",
                  "name": "options",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "label",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "status",
  "value": "visible"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompleteProfileCurriculumItemFormQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "organizationMembership",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileValueNodeConnection",
                    "kind": "LinkedField",
                    "name": "profileValues",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileValueNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileValue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "profileField",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormAnswer",
                                "kind": "LinkedField",
                                "name": "webFormAnswer",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebForm",
                        "kind": "LinkedField",
                        "name": "profileWebForm",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ProfileSettingsProfileFormFieldsFragment"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ProfileSettingsCustomFormFieldsFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CompleteProfileCurriculumItemFormQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "organizationMembership",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileValueNodeConnection",
                    "kind": "LinkedField",
                    "name": "profileValues",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileValueNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileValue",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "profileField",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormAnswer",
                                "kind": "LinkedField",
                                "name": "webFormAnswer",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v7/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebForm",
                        "kind": "LinkedField",
                        "name": "profileWebForm",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "defaultFields",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "isDefault",
                            "value": true
                          },
                          (v10/*: any*/)
                        ],
                        "concreteType": "ProfileFieldNodeConnection",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileFieldNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "profileFields(isDefault:true,status:\"visible\")"
                      },
                      {
                        "alias": "customFields",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "isDefault",
                            "value": false
                          },
                          (v10/*: any*/)
                        ],
                        "concreteType": "ProfileFieldNodeConnection",
                        "kind": "LinkedField",
                        "name": "profileFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileFieldNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileField",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "profileFields(isDefault:false,status:\"visible\")"
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "23b57d170e10ca3ba7bc7b12bc0cb41a",
    "id": null,
    "metadata": {},
    "name": "CompleteProfileCurriculumItemFormQuery",
    "operationKind": "query",
    "text": "query CompleteProfileCurriculumItemFormQuery(\n  $userId: ID!\n  $organizationId: ID!\n) {\n  user: node(id: $userId) {\n    __typename\n    ... on User {\n      organizationMembership(organizationId: $organizationId) {\n        profileValues {\n          edges {\n            node {\n              id\n              profileField {\n                webFormQuestionId\n                id\n              }\n              value\n              selectedOptions\n              webFormAnswer {\n                body\n                selectedOptions\n                id\n              }\n            }\n          }\n        }\n        organization {\n          profileWebForm {\n            currentRevision {\n              id\n              webFormId\n              questions {\n                edges {\n                  node {\n                    id\n                    type\n                    richEditorBody\n                    ordering\n                    isRequired\n                    options {\n                      id\n                      label\n                    }\n                  }\n                }\n              }\n            }\n            id\n          }\n          ...ProfileSettingsProfileFormFieldsFragment\n          ...ProfileSettingsCustomFormFieldsFragment\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ProfileSettingsCustomFormFieldsFragment on Organization {\n  customFields: profileFields(status: visible, isDefault: false) {\n    edges {\n      node {\n        id\n        title\n        isPrivate\n        webFormQuestionId\n      }\n    }\n  }\n  profileWebForm {\n    currentRevision {\n      questions {\n        edges {\n          node {\n            id\n            type\n            richEditorBody\n            options {\n              id\n              label\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ProfileSettingsProfileFormFieldsFragment on Organization {\n  defaultFields: profileFields(status: visible, isDefault: true) {\n    edges {\n      node {\n        id\n        title\n        isPrivate\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37b149226f4c8a63f7010453c94bc16e";

export default node;
